// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider[data-v-7427b2c6]::before {\n  background: #e1dddd !important;\n}\n", ""]);
// Exports
module.exports = exports;
